const removeEmptySearchParameters = (searchParameters: Record<string, string>) => {
    return Object.fromEntries(
        Object.entries(searchParameters).filter(([, value]) => {
            return !!value;
        }),
    );
};

export const SearchParameterUtils = {
    removeEmptySearchParameters,
};
